import { queryFirst, remove } from './domUtil';
import { getJSON } from './util';

const storeEventsContainer = queryFirst('.store-events-container');
const preferredStoreLabel = queryFirst('.page-title .preferred-store-label', storeEventsContainer);
const setPreferredStoreContainer = queryFirst('.set-preferred-store', storeEventsContainer);
const setPreferredStoreLinkEl = queryFirst('a', setPreferredStoreContainer);

/**
 * Method to remove preferred store link
 */
function removePreferredStoreLink() {
    remove(setPreferredStoreContainer);
}

/**
 * Method to show preferred store label beside store name
 */
function showPreferredStoreLabel() {
    if (preferredStoreLabel) {
        preferredStoreLabel.textContent = setPreferredStoreLinkEl?.dataset?.preferredStoreText;
    }
}

/**
 * Method to initialize events
 */
function initilizeEvents() {
    if (setPreferredStoreLinkEl) {
        setPreferredStoreLinkEl.addEventListener('click', (event) => {
            const { actionUrl, storeId } = event.target.dataset;

            $.spinner().start();
            getJSON(actionUrl, 'POST', { storeID: storeId }, (response) => {
                if (response.message === 'success') {
                    showPreferredStoreLabel();
                    removePreferredStoreLink();
                }
                $.spinner().stop();
            }, () => {
                $.spinner().stop();
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initilizeEvents();
});
